import React from 'react';
import { FiArrowRight } from 'react-icons/fi';

const FinalCTA = () => {
  return (
    <section className="py-32 px-6 bg-navy text-cream text-center">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-fraunces text-5xl md:text-6xl mb-8 leading-tight">
          Let's get your document <span className="italic text-brass-light">signed and done.</span>
        </h2>
        <p className="text-xl text-cream/70 mb-12 max-w-2xl mx-auto leading-relaxed">
          Book online or give us a call. We'll confirm a time, give you a flat quote, and show up ready to work.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="#services" 
            className="w-full sm:w-auto flex items-center justify-center gap-3 bg-brass text-navy px-12 py-4 rounded-full text-base font-bold hover:bg-brass-light transition-all shadow-lg group"
          >
            Book Your Appointment <FiArrowRight className="group-hover:translate-x-1 transition-transform" />
          </a>
          <a 
            href="tel:2405713117" 
            className="w-full sm:w-auto flex items-center justify-center bg-transparent border border-cream/30 text-cream px-12 py-4 rounded-full text-base font-bold hover:bg-cream hover:text-navy transition-all"
          >
            Call or Text (240) 571-3117
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;